import { render, staticRenderFns } from "./youtube_setup.vue?vue&type=template&id=4d547c61&"
import script from "./youtube_setup.vue?vue&type=script&lang=js&"
export * from "./youtube_setup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports